import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function PasswordResetRequest() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setSubmitting(true);
    try {
      const r = await api.post("/auth/password-reset-request", { email: email.trim() });
      setSent(true);
      toast.success(r.data?.message || "Nachricht versendet, falls Konto existiert");
    } catch (e) {
      // Never reveal existence. Still show the neutral success.
      setSent(true);
    } finally { setSubmitting(false); }
  }

  if (sent) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6" data-testid="pw-reset-sent">
        <div className="max-w-md text-center space-y-4">
          <div className="text-5xl">📬</div>
          <div className="text-2xl font-black uppercase">E-Mail gesendet</div>
          <div className="text-zinc-400">
            Falls ein Konto zu dieser E-Mail existiert, wurde eine Nachricht mit Reset-Link versendet.
            Der Link ist 30 Minuten gültig.
          </div>
          <Link to="/login" className="inline-block text-cyan-400 hover:underline">Zurück zum Login</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <form onSubmit={submit} className="w-full max-w-sm space-y-4" data-testid="pw-reset-form">
        <div className="text-2xl font-black uppercase">Passwort zurücksetzen</div>
        <div className="text-sm text-zinc-500">
          Wir schicken dir einen einmaligen Link. Der Link ist 30 Minuten gültig.
        </div>
        <div>
          <Label>E-Mail</Label>
          <Input required type="email" data-testid="pw-reset-email" value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <Button type="submit" disabled={submitting} data-testid="pw-reset-submit" className="w-full h-12 rounded-sm">
          {submitting ? "Senden..." : "Link senden"}
        </Button>
        <div className="text-center text-sm text-zinc-500">
          <Link to="/login" className="text-cyan-400 hover:underline">Zurück zum Login</Link>
        </div>
      </form>
    </div>
  );
}
